import React from 'react';
import IntlMessages from 'util/IntlMessages';
import {notifications} from './data';
import CustomScrollbars from 'util/CustomScrollbars';
import NotificationItem from './NotificationItem';

class AppNotification extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        notifData: []
    }

    static getDerivedStateFromProps(nextProps, prevState){
    
        if(nextProps.dataNotif !== prevState.notifData){
            return {
                notifData: nextProps.dataNotif,
            }
        } 
 
         return null
     }

    render() {
        return (
            <CustomScrollbars className="messages-list scrollbar" style={{height: 280}}>
                {this.state.notifData.length !== 0 ? (
                    <ul className="list-unstyled">
                        {this.state.notifData.map((notification, index) => <NotificationItem key={index} notification={notification}/>)
                            }
                    </ul>
                ):(
                    <div className="d-flex align-items-center h-100 justify-content-center">
                        <IntlMessages id="appNotification.message"/>
                    </div>
                )}
                
            </CustomScrollbars>
        )
    }
}

export default AppNotification;




// WEBPACK FOOTER //
// ./components/AppNotification/index.js